import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface OrganizationState {
  currentOrganization: any | null;
}

const initialState: OrganizationState = {
  currentOrganization: null,
};

const organizationSlice = createSlice({
  name: "organization",

  initialState,

  reducers: {
    setOrganization: (
      state,
      action: PayloadAction<any>,
    ) => {
      state.currentOrganization =
        action.payload;
    },

    clearOrganization: (state) => {
      state.currentOrganization = null;
    },

  },
});

export const {
  setOrganization,
  clearOrganization,
} = organizationSlice.actions;

export default organizationSlice.reducer;
